import React from "react";
import { assets } from "../../assets/assets";
import "./style/detailsUnit.css";
import ar from "../../lang/ar";
import en from "../../lang/en";
function DetailsUnit({ villa, isMobile, lang }) {
  if (!villa) return null;
const translations = lang === "ar" ? ar : en;
  return (
    <div className="details-unit mt-2">
      <div
        className="details-unit-items"
        style={{ gap: isMobile ? "15px" : "5px" }}
      >
        {/* Bedrooms */}
        <div className="unit-item">
          <div className="unit-info">
            <img src={assets.bed} alt="icon-bed" />
            <p className="m-0 p-0">{villa.num_of_bedrooms ?? "-"}</p>
          </div>
          <p className="m-0 p-0">{translations.bedrooms}</p>
        </div>

        {/* Bathrooms */}
        <div className="unit-item">
          <div className="unit-info">
            <img src={assets.bathroom} alt="icon-bathroom" />
            <p className="m-0 p-0">{villa.num_of_bathrooms ?? "-"}</p>
          </div>
          <p className="m-0 p-0">{translations.bathrooms}</p>
        </div>

        {/* Land Area */}
        <div className="unit-item">
          <div className="unit-info">
            <img src={assets.land_area} alt="icon-land" />
            <p className="m-0 p-0">
              {villa.land_area ? `${villa.land_area} ${lang === "ar" ? " م²" : "m"}` : "-"}
            </p>
          </div>
          <p className="m-0 p-0">{lang === "ar" ? "مساحة الأرض" : "Land Area"}</p>
        </div>

        {/* Price */}
        <div className="unit-item">
          <div className="unit-info">
            <img src={assets.builtUp_area} alt="icon-price" />
            <p className="m-0 p-0">
              {villa.actual_price ? `${villa.actual_price} EGP` : "-"}
            </p>
          </div>
          <p className="m-0 p-0">{lang === "ar" ? "السعر" : "Price"}</p>
        </div>

        {/* Built-up Area */}
        <div className="unit-item">
          <div className="unit-info">
            <img src={assets.builtUp_area} alt="icon-saleable" />
            <p className="m-0 p-0">
              {villa.built_up_area ? `${villa.built_up_area} m²` : "-"}
            </p>
          </div>
          <p className="m-0 p-0">{lang === "ar" ? "مساحة البناء" : "Built-up Area"}</p>
        </div>

        {/* Finish Date */}
        <div className="unit-item">
          <div className="unit-info">
            <img src={assets.land_area} alt="icon-date" />
            <p className="m-0 p-0">{villa.progress_deadline ?? "-"}</p>
          </div>
          <p className="m-0 p-0">{lang === "ar" ? "تاريخ الإنجاز" : "Finish Date"}</p>
        </div>
        <div className="unit-item">
          <div className="unit-info">
            <img src={assets.direction} alt="icon-direction" />
            <p className="m-0 p-0">{villa.direction || "_"} </p>
          </div>
          <p className="m-0 p-0">{lang === "ar" ? "اتجاه البناء" : "DFront Compassn"}</p>
        </div>
      </div>
    </div>
  );
}

export default DetailsUnit;
